/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BackupOperationEnum = 'COPY_TO_BACKUP' | 'MOVE_TO_BACKUP' | 'DELETE_FROM_BACKUP' | 'RESTORE_FROM_BACKUP';

export const BackupOperationEnum = {

    COPY_TO_BACKUP: 'COPY_TO_BACKUP' as BackupOperationEnum,

    MOVE_TO_BACKUP: 'MOVE_TO_BACKUP' as BackupOperationEnum,

    DELETE_FROM_BACKUP: 'DELETE_FROM_BACKUP' as BackupOperationEnum,

    RESTORE_FROM_BACKUP: 'RESTORE_FROM_BACKUP' as BackupOperationEnum
};

